import { React, useEffect } from "react";
import { LuRefreshCw } from "react-icons/lu";
import ScenarioAnalysisChart from "./ScenarioAnalysisChart";

export const ScenarioAnalysis = ({
  isGetClientGoal,
  isInvestment,
  isMonthly,
  setMonthly,
  setisAccoumulated,
  isAccoumulated,
  isTarget,
  isDelay,
  setDelay,
  setTargetreturn,
  isAnnualStepUp,
  setIsAnnualStepUp,
  abcdDAta,
  setAbcdData,
  activeTab,
  selectedCard,
  currentGoal,
  allExternalFolios,
}) => {
  useEffect(() => {
    console.log("abcdDAta", abcdDAta);
    if (abcdDAta?.sip > 0) {
      isGetClientGoal.monthlysaving = abcdDAta?.sip;
    }
    if (abcdDAta?.targetYear > 0) {
      isGetClientGoal.goalYear = abcdDAta?.targetYear;
    }
    if (abcdDAta?.cagr > 0) {
      isGetClientGoal.expectedReturn = abcdDAta?.cagr;
    }
    if (abcdDAta?.stepUp > 0) {
      isGetClientGoal.annualStepUp = abcdDAta?.stepUp;
    }
    if (abcdDAta?.startYear > 0) {
      isGetClientGoal.startYear = abcdDAta?.startYear;
    }

    // setInflationRate(isGetClientGoal.inflation);
  }, [abcdDAta, currentGoal]);

  return (
    <div className="mt-2 mb-5">
      <ScenarioAnalysisChart
        isAccoumulated={isAccoumulated}
        isTarget={isTarget}
        isDelay={isDelay}
        isAnnualStepUp={isAnnualStepUp}
        isMonthly={isMonthly}
        isGetClientGoal={isGetClientGoal}
        activeTab={activeTab}
        selectedCard={selectedCard}
        currentGoal={currentGoal}
        allExternalFolios={allExternalFolios}
      />
    </div>
  );
};
